export enum RFQResponseActions {
    Work = 'work',
    Purchase = 'purchase',
    Variation = 'variation',
}
